<template>
  <div>
    <section class="notifications">
      <div class="notifications__content">
        <header class="notifications__header">
          <h1 v-if="unreadNotifications > 0">{{ unreadNotifications
            }} {{ getTranslations.home_notifications_unread }}</h1>
          <a style="cursor:pointer" @click.stop.prevent="clearData">{{ getTranslations.home_notifications_clear_all }}</a>
        </header>
        <div class="notifications__list">
          <ul v-for="(notificationToday, index) in notificationTodayArrays" :key="index">
            <li :class="[ notificationToday.readStatus ? 'read' : '', notificationToday.notificationCategoryDTO.name === 'Bonus Points' ? 'bonus' : '' ]">
              <div class="notifications__list__icon">
                <img :src="notificationToday.notificationCategoryDTO.imgUrl" alt="">
              </div>
              <div class="notifications__list__text">
                <strong>{{ notificationTranslationMethod(notificationToday.notificationCategoryDTO.name) }}</strong> {{ notificationTranslationMethodText(notificationToday.notificationCategoryDTO.name, notificationToday.notificationCategoryDTO.value, notificationToday.text) }}
                <span>{{ notificationToday.notificationDate | getFormat }}</span>
              </div>
              <div class="notifications__list__button" v-if="notificationsWithoutCheckItButton(notificationToday.notificationCategoryDTO.name)">
                <button class="btn2 btn2--std btn2--small "
                        @click.prevent="checkItToday(notificationToday)">
                  {{ getTranslations.home_notifications_check_it }}
                </button>
              </div>
            </li>
          </ul>
          <div v-for="(notificationBar, index) in notificationArraysBar" :key="index">
            <div class="notifications__list__seperator">
              <span>{{ notificationBar.notificationDate | getFormatForBar }}</span>
            </div>
            <ul v-for="(notification, index) in notificationArrays" :key="index"
                v-if="hasTheSameDate(notification.id, notificationBar.notificationDate)">
              <li :class="[ (notification.data.readStatus == true) ? 'read' : '' ]">
                <div class="notifications__list__icon">
                  <img :src="notification.data.notificationCategoryDTO.imgUrl" alt="">
                </div>
                <div class="notifications__list__text">
                  <strong>{{ notificationTranslationMethod(notification.data.notificationCategoryDTO.name) }}</strong>
                  {{ notificationTranslationMethodText(notification.data.notificationCategoryDTO.name, notification.data.notificationCategoryDTO.value, notification.data.text) }}
                  <span>{{ notification.data.notificationDate | getFormat }}</span>
                </div>
                <div class="notifications__list__button" v-if="notificationsWithoutCheckItButton(notification.data.notificationCategoryDTO.name)">
                  <button class="btn2 btn2--std btn2--small "
                          @click.prevent="checkIt(notification.data)">{{ getTranslations.home_notifications_check_it
                    }}
                  </button>
                </div>
              </li>
            </ul>
          </div>
          <input v-show="extraArraysLength" type="submit" value="···"
                 class="load-more btn2 btn2--std btn2--small " @click.prevent="displayMore">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }] */
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import Vue from 'vue';
import RoundUpMixin from '@/common/mixins/roundUp';
import LevelUp from './modals/LevelUp';
import PrizeDetails from './modals/PrizeDetails';
import Ranking from './modals/Ranking';
import SpinWheel from './modals/SpinWheel';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'notifications',
  components: {
    LevelUp,
    PrizeDetails,
    Ranking,
    SpinWheel,
  },
  mixins: [RoundUpMixin],
  data() {
    return {
      showedModal: false,
      showmore: false,
      extraArrays: [],
      userNotifications: [],
      displayNotifications: [],
      displayDifferentDaysNotifications: [],
      displayBlackBar: [],
      unreadNotifications: 0,
      moreNotifications: false,
      hiddenNotificationsNumber: 3,
    };
  },
  beforeRouteEnter(to, from, next) {
    // eslint-disable-next-line
    console.log('==> inside component\'s beforeRouteEnter:');
    if (process.env.NODE_ENV !== 'production') {
      const deepCloneForStrictError = JSON.parse(JSON.stringify(localStorage.getItem('locale')));
      moment.locale(deepCloneForStrictError);
    } else {
      moment.locale(localStorage.getItem('locale'));
    }
    next();
  },
  created() {
    this.getUserNotifications().then(() => {
      this.numberOfUnreadNotifications();
    });
  },
  mounted() {
    this.numberOfUnreadNotifications();
    if (this.unreadNotifications > 0) {
      this.changeNotificationReadStatus().then(() => {
        this.getUserNotifications().then(() => {
          // eslint-disable-next-line
          this.userNotifications = this.notifications;
          this.numberOfUnreadNotifications();
        });
      });
    }
  },
  methods: {
    ...mapActions('profile', [
      'changeNotificationReadStatus',
      'getUserNotifications',
      'clearNotifications',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'setShowmodalForLevelUp',
      'setShowmodalForRanking',
      'setShowmodalForDefaultPrizeDetails',
      'setShowModalForGrandPrize',
      'setCheckedNotificationId',
      'setCheckedNotificationReadStatus',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
    ]),
    numberOfUnreadNotifications() {
      // comment next line for dev purpose
      this.userNotifications = this.notifications;
      this.unreadNotifications = 0;
      for (let i = 0; i < this.userNotifications.length; i += 1) {
        if (this.userNotifications[i].readStatus === false) {
          this.unreadNotifications = this.unreadNotifications + 1;
        }
      }
    },
    notificationsWithoutCheckItButton(notification) {
      switch (notification) {
      case this.getNotificationsNames.bonusRegistration:
        return false;
      case this.getNotificationsNames.bonusPointsRank:
        return false;
      case this.getNotificationsNames.bonusPointsReferral:
        return false;
      case this.getNotificationsNames.bonusPointsLevelUp:
        return false;
      case this.getNotificationsNames.bundlePurchaseWarning:
        return false;
      default:
        return true;
      }
    },
    notificationTranslationMethodText(name, value, text) {
      /* eslint-disable */
      console.log('The text Name is  ' + name);
      console.log('The text Value is  ' + value);
      // only for this case we want the value of NotificationDTO for the referral notification
      if (value === 'Referral') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_referral_registration_before_username')).toString()];
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_referral_registration_after_username')).toString()];
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'Ranking') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_ranking_before')).toString()]; // You earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_ranking_after')).toString()]; // Bonus Points for sharing your Rank on Facebook!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'LevelUp') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_level_up_before')).toString()]; // You earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_level_up_after')).toString()]; // Bonus Points for sharing your Level Up Success on Facebook!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'Registration') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_registration_before')).toString()]; // You connected successfully to Facebook and earned
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bonus_registration_after')).toString()]; // Bonus Points!
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'BundlePurchaseWarning') {
        const text1 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bundle_purchase_before')).toString()];
        const text3 = this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_bundle_purchase_after')).toString()];
        return text1 + ' '+ text + ' ' + text3;
      } else if (value === 'PendingSpinningWheelGame') {
        return this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'notifications_spin_wheel_text')).toString()];
      }
//      console.log('The text in the Notification that has to be translated ' + this.getTranslations[(this.getTranslationsKeys.filter(key => key === text)).toString()]);
      return this.getTranslations[(this.getTranslationsKeys.filter(key => key === text)).toString()];
      /* eslint-enable */
    },
    notificationTranslationMethod(text) {
      /* eslint-disable */
      console.log('The text is ' + text);
      if (text === this.getNotificationsNames.grandPrize) {
        text = 'home_modals_prize_details_grand_prize';
      }
      if (text === this.getNotificationsNames.monthlyPrize) {
        text = 'home_modals_prize_details_monthly_prize';
      }
      if (text === this.getNotificationsNames.dailyPrize) {
        text = 'home_modals_prize_details_daily_prize';
      }
      if (text === this.getNotificationsNames.weeklyPrize) {
        text = 'home_modals_prize_details_weekly_prize';
      }
      if (text === this.getNotificationsNames.bonusRegistration) {
        text = 'home_modals_notifications_bonus_registration';
      }
      if (text === this.getNotificationsNames.bonusPointsReferral) {
        text = 'home_modals_notifications_bonus_referral';
      }
      if (text === this.getNotificationsNames.bonusPointsLevelUp) {
        text = 'home_modals_notifications_bonus_points';
      }
      if (text === this.getNotificationsNames.bonusPointsRank) {
        text = 'home_modals_notifications_bonus_games';
      }
      if (text === this.getNotificationsNames.bundlePurchaseWarning) {
        text = 'home_modals_notifications_bundle_purchase';
      }
//      console.log('The text in the Notification that has to be translated ' + this.getTranslations[(this.getTranslationsKeys.filter(key => key === text)).toString()]);
      return this.getTranslations[(this.getTranslationsKeys.filter(key => key === text)).toString()];
      /* eslint-enable */
    },
    displayMore() {
      this.moreNotifications = true;
      this.extraArrays = [];
      this.displayBlackBar = [];
    },
    checkItToday(notification) {
      this.storeModalForHomePage(null);
      for (let i = 0; i < this.userNotifications.length; i += 1) {
        if (this.userNotifications[i].id === notification.id) {
          if (!this.checkIfNotificationIsOfType(this.userNotifications[i], 'PendingSpinningWheelGame')) {
            this.userNotifications[i].readStatus = true;
          }
          break;
        }
      }
      this.sendNotificationIdtoDB(notification);
    },
    checkIt(notification) {
      this.storeModalForHomePage(null);
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        if (this.displayDifferentDaysNotifications[i].data.id === notification.id) {
          if (!this.checkIfNotificationIsOfType(this.displayDifferentDaysNotifications[i].data, 'PendingSpinningWheelGame')) {
            this.displayDifferentDaysNotifications[i].data.readStatus = true;
          }
          break;
        }
      }
      this.sendNotificationIdtoDB(notification);
    },
    checkIfNotificationIsOfType(notification, type) {
      return notification.notificationCategoryDTO.value === type;
    },
    sendNotificationIdtoDB(notificationIdtoDB) {
      this.setCheckedNotificationId({ value: notificationIdtoDB.id });
      this.setCheckedNotificationReadStatus({ value: notificationIdtoDB.readStatus });
      this.setNotificationRewardName({ value: notificationIdtoDB.text });
      this.setNotificationPrizeWon({ value: notificationIdtoDB.hasWon });
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.levelUp) {
        // eslint-disable-next-line
        const notificationLevelupData = {
          userLevel: notificationIdtoDB.userLevel,
          bonusPoints: notificationIdtoDB.bonusPoints,
          gamesEarned: notificationIdtoDB.gamesEarned,
        };
        // temp
        this.setShowmodalForLevelUp({ notificationLevelupObject: notificationLevelupData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.topRanking) {
        const notificationRankingData = {
          userLevel: notificationIdtoDB.userLevel,
          bonusPoints: notificationIdtoDB.bonusPoints,
          gamesEarned: notificationIdtoDB.gamesEarned,
        };
        // temp
        this.setShowmodalForRanking({ notificationRankingObject: notificationRankingData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.monthlyPrize ||
        notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.weeklyPrize || notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.dailyPrize) {
        if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.monthlyPrize) {
          const notificationPrizeDetailsData = this.getMonthlyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        } else if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.weeklyPrize) {
          const notificationPrizeDetailsData = this.getWeeklyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        } else if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.dailyPrize) {
          const notificationPrizeDetailsData = this.getDailyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        }
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.grandPrize) {
        const notificationPrizeDetailsData = this.getGrandPrize;
        // temp
        this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
      }
      this.showModalMethod(notificationIdtoDB.notificationCategoryDTO.name);
      // the status of the notifications changes from mounted hook when the user enters in page and not as below with the check it button
//      this.$axios.get(`api/changeNotificationStatus?notificationId=${notificationIdtoDB.id}`).then((response) => {
//        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
//          this.showModalMethod(notificationIdtoDB.notificationCategoryDTO.name);
//        }
//      });
    },
    showModalMethod(notificationModalName) {
      if (notificationModalName === this.getNotificationsNames.monthlyPrize || notificationModalName === this.getNotificationsNames.grandPrize ||
        notificationModalName === this.getNotificationsNames.weeklyPrize || notificationModalName === this.getNotificationsNames.dailyPrize) {
        this.storeModalForHomePage(PrizeDetails);
        this.showModal();
      } else if (notificationModalName === this.getNotificationsNames.levelUp) {
        this.storeModalForHomePage(LevelUp);
        this.showModal();
      } else if (notificationModalName === this.getNotificationsNames.topRanking) {
        this.storeModalForHomePage(Ranking);
        this.showModal();
      } else if (notificationModalName === this.getNotificationsNames.spinWheel) {
        this.storeModalForHomePage(SpinWheel);
        this.showModal();
      }
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          this.getUserNotifications().then(() => {
            this.userNotifications = this.notifications;
            this.numberOfUnreadNotifications();
          });
          if (!this.showedModal) {
            this.showedModal = true;
            this.storeModalForHomePage(null);
          } else {
            this.storeModalForHomePage(null);
          }
        });
      });
      /* eslint-enable */
    },
    clearData() {
      this.clearNotifications().then(() => {
        this.displayNotifications = [];
        this.displayDifferentDaysNotifications = [];
        this.displayBlackBar = [];
        this.extraArrays = [];
        this.showmore = false;
        this.userNotifications = [];
      });
    },
    hasTheSameDate(notificationDate1, notificationDate2) {
      return (moment(notificationDate1).format('L') === moment(notificationDate2).format('L'));
    },
  },
  computed: {
    ...mapState('common', [
      'modalForHomePage',
    ]),
    ...mapState('profile', [
      'notifications',
      'jwtInVuex',
    ]),
    ...mapGetters('common', [
      'getNotificationsNames',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationsKeys',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getGrandPrize',
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
    ]),
    extraArraysLength() {
      return this.showmore;
    },
    notificationTodayArrays() {
      /* eslint-disable */
      this.displayNotifications = [];
      this.displayDifferentDaysNotifications = [];
      this.displayBlackBar = [];
      for (let i = 0; i < this.userNotifications.length; i += 1) {
        this.displayNotifications.push(this.userNotifications[i]);
      }
      for (let i = this.userNotifications.length - 1; i >= 0; i--) {
        if (moment(this.userNotifications[i].notificationDate).format('L') === (moment(Date.now()).format('L'))) {
          delete this.displayNotifications[i];
        }
      }
      this.displayNotifications = this.displayNotifications.filter(function (e) {  //delete null values
        return e
      });
      for (let i = 0; i < this.displayNotifications.length; i += 1) {
        if (i === 0) {
          let first = {
            id: this.displayNotifications[i].notificationDate,
            data: this.displayNotifications[i],
          };
          this.displayDifferentDaysNotifications.push(first);
        }
        else {
          let notific = {
            id: '',
            data: '',
          };
          for (let k = 0; k < this.displayDifferentDaysNotifications.length; k += 1) {
            if (moment(this.displayNotifications[i].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[k].data.notificationDate).format('L')) {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
              break;
            }
            else {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
            }
          }
          this.displayDifferentDaysNotifications.push(notific);
        }
      }
      return this.userNotifications.filter(function (notification) {
        return moment(notification.notificationDate).format('L') === moment(Date.now()).format('L');
      });
    },
    notificationArraysBar() { //notifications from the same date have the same notificationDate
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        let notific = {
          id: '',
          notificationDate: '',
        };
        if (i === 0) {
          let first = {
            id: this.displayDifferentDaysNotifications.length - 1,
            notificationDate: this.displayDifferentDaysNotifications[i].data.notificationDate,
          };
          this.displayBlackBar.push(first);
        }
        else {
          let isAlreadyinArray = false;
          for (let k = 0; k < this.displayBlackBar.length; k += 1) {
            isAlreadyinArray = false;
            if (moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L')) {
              break;
            }
            else {
              if (!(moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L'))) {
                isAlreadyinArray = true;
                notific.id = k;
                notific.notificationDate = this.displayDifferentDaysNotifications[i].data.notificationDate;
              }
            }
          }
          if (isAlreadyinArray) {
            this.displayBlackBar.push(notific);
          }
        }
      }
      this.displayBlackBar.sort(
        (a, b) => b.notificationDate - a.notificationDate,
      );
      this.showmore = false;
      if ((this.displayBlackBar.length > this.hiddenNotificationsNumber) && this.moreNotifications === false) {
        this.showmore = true;
        for (let k = this.hiddenNotificationsNumber; k < this.displayBlackBar.length; k += 1) {
          this.extraArrays.push(this.displayBlackBar[k]);
          delete this.displayBlackBar[k];
        }
      }
      this.displayBlackBar = this.displayBlackBar.filter(function (e) {  //delete null values
        return e
      });
      return this.displayBlackBar;
      /* eslint-enable */
    },
    notificationArrays() {
      return this.displayDifferentDaysNotifications;
    },
  },
  filters: {
    getFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getFormatForBar(dateInBar) {
      return moment(dateInBar).format('LL');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Notifications.vue